let appTeamsSlider = false;
export const appTeamSlider = {
  create: function () {
    var that = this;
    if ($('.js-team-slider').length) {
      appTeamsSlider = new Swiper('.js-team-slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        keyboard: {
          enabled: true,
        },
        navigation: {
          nextEl: '.js-team-slider-next',
          prevEl: '.js-team-slider-prev',
        },
        a11y: {
          enabled: false,
        },
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 500px
          500: {
            slidesPerView: 2,
            spaceBetween: 28,
          },
          // when window width is >= 768px
          768: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
        on: {
          init: function () {
            // Set aria-labels dynamically from markup
            const nextButton = document.querySelector('.js-team-slider-next');
            const prevButton = document.querySelector('.js-team-slider-prev');

            if (nextButton) {
              nextButton.setAttribute(
                'aria-label',
                nextButton.getAttribute('data-aria-label'),
              );
            }
            if (prevButton) {
              prevButton.setAttribute(
                'aria-label',
                prevButton.getAttribute('data-aria-label'),
              );
            }
          },
        },
      });
      //console.log(appTeamsSlider);
    }
  },
};
